import parentApi from "store/parentApi"

const propGoApi = parentApi.injectEndpoints({
  endpoints: (build) => ({
    // Modelled as a mutation, not a query: the payload carries live
    // credentials (token/refreshToken) and every call mints a fresh pair, so
    // it must never be cached, persisted, or shared across screen visits.
    getPropGoQrInfo: build.mutation({
      query: () => ({
        url: `/users/prop_go_qr_info`,
        method: "POST",
      }),
    }),

    pushPropGoCall: build.mutation({
      query: (payload) => ({
        url: `/users/push_call_notification`,
        method: "PUT",
        body: {
          ...(payload?.phone
            ? { phone: payload.phone }
            : { client_id: payload?.clientId }),
          ...(payload?.name && { name: payload.name }),
        },
      }),
    }),
  }),

  overrideExisting: false,
})

export const { useGetPropGoQrInfoMutation, usePushPropGoCallMutation } =
  propGoApi
